export type LexicalJsonValue = {
  root: {
    children: [
      {
        children: [
          {
            detail: number;
            format: number;
            mode: string;
            style: string;
            text: string;
            type: string;
            version: number;
          },
        ];
        direction: string;
        format: string;
        indent: number;
        type: string;
        version: number;
      },
    ];
    direction: string;
    format: string;
    indent: number;
    type: string;
    version: number;
  };
};

export const LX_DEFAULT_VALUE: LexicalJsonValue = {
  root: {
    children: [
      {
        children: [
          {
            detail: 0,
            format: 0,
            mode: "normal",
            style: "",
            text: "",
            type: "text",
            version: 1,
          },
        ],
        direction: "ltr",
        format: "",
        indent: 0,
        type: "paragraph",
        version: 1,
      },
    ],
    direction: "ltr",
    format: "",
    indent: 0,
    type: "root",
    version: 1,
  },
};

export const LX_DEFAULT_VALUE_STRING = JSON.stringify(LX_DEFAULT_VALUE);

export const isValidJSON = (value: string) => {
  try {
    const json = JSON.parse(value);
    if (json && typeof json === "object") {
      return true;
    }
  } catch {
    console.error("Invalid JSON");
  }
  return false;
};

/**
 * @description
 * Convert a string or doubleStringified obj to a Lexical JSON string.
 * @param {string} value
 * @returns {string}
 */
export const convertToLexicalJSONString = (value: string) => {
  try {
    if (value?.startsWith(LX_DEFAULT_VALUE_STRING.substring(0, 6))) {
      return value;
    }

    // Double stringified value
    const parsedValue = JSON.parse(value);
    if (parsedValue.startsWith(LX_DEFAULT_VALUE_STRING.substring(0, 6))) {
      return parsedValue;
    }
  } catch (error) {
    // Raw text value
    const newLxValue = LX_DEFAULT_VALUE;
    newLxValue.root.children[0].children[0].text = value;
    return JSON.stringify(newLxValue);
  }
};

/**
 * @description
 * Prevent double stringification.
 *
 * If value is an object, stringify it.
 * If value is a string, return it.
 * @param {string|object} value
 * @returns {string}
 */
export function stringifyIfObject(obj) {
  if (typeof obj == "object") return JSON.stringify(obj);
  else {
    // alert("found already stringified object")
    return obj;
  }
}
